// Captures the browser's beforeinstallprompt event at module load, before any
// component mounts. The event fires once per page load and only on
// Chromium — if nothing has subscribed by then it's lost, so this module
// must be imported for its side effect as early as possible (see index.js).
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Suppress the browser's own mini-infobar so the in-app prompt is the
    // only install UI the user sees.
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((cb) => cb(e));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
  });
}

export function getDeferredInstallPrompt() {
  return deferredPrompt;
}

// The captured event is single-use — call this once .prompt() has been
// invoked so a second tap doesn't replay a stale choice.
export function clearDeferredInstallPrompt() {
  deferredPrompt = null;
}

// The event may arrive after a component using it has already mounted;
// callback fires with the event if/when that happens. Returns an unsubscribe.
export function onInstallPromptAvailable(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
